enum Origin {
  ONLINE_APPLICATION = 'ONLINE_APPLICATION',
  ONLINE_CHECKOUT = 'ONLINE_CHECKOUT',
  ONLINE_PURCHASE = 'ONLINE_PURCHASE',
  PARTNER_PORTAL_SERVICES = 'PARTNER_PORTAL_SERVICES',
}

export default Origin;
